import { Component, OnInit, ChangeDetectionStrategy, Input, Output, EventEmitter } from '@angular/core';

import { Customer, Salutation } from "../../../models"

@Component({
	selector: 'checkout-customer-display-presentation',
	templateUrl: "./checkout-customer-display.presentation.html",
	styles: [require("./checkout-customer-display.presentation.scss")],
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class CheckoutCustomerDisplayPresentation {

	@Input() customer: Customer;
	@Output() selectCustomerClicked = new EventEmitter<void>();
	@Output() removeCustomerClicked = new EventEmitter<void>();
	@Output() editCustomerClicked = new EventEmitter<void>();

	protected salutation = Salutation


}



// WEBPACK FOOTER //
// ./src/app/components/checkout-components/checkout-customer-display/checkout-customer-display.presentation.ts